<template>
	<div class="tutorial-welcome">
		<div class="tutorial-welcome__left">
			<div class="tutorial-welcome__logo">
				<div class="tutorial-welcome__logo-mark">
					<img
						src="@/assets/images/tutorial/welcome-logo-mark.png"
						alt=""
					/>
				</div>
				<img
					src="@/assets/images/tutorial/welcome-logo-education.svg"
					alt="Luca Education"
					class="tutorial-welcome__logo-text"
				/>
			</div>
			<div class="tutorial-welcome__content">
				<div class="tutorial-welcome__title">
					Chào mừng bạn đến với Luca Education
				</div>
				<div class="tutorial-welcome__text">
					<p>
						Để giúp bạn làm quen nhanh chóng với phần mềm, chúng ta
						sẽ cùng thực hiện một vài thiết lập cơ bản đầu tiên.
					</p>
					<p>Hướng dẫn này chỉ mất khoảng 3–5 phút.</p>
				</div>
				<div class="tutorial-welcome__text">
					<p>Bạn sẽ:</p>
					<div v-for="item in checklist" :key="item" class="flex items-center gap-2">
						<img
							class="w-4 h-4"
							src="@/assets/images/icons/tick.png"
							alt=""
						/>
						<div>{{ item }}</div>
					</div>
				</div>
				<div class="tutorial-welcome__alert">
					<img
						src="@/assets/images/tutorial/info.svg"
						alt=""
						width="20"
						height="20"
						class="flex-shrink-0"
					/>
					<span>
						Mọi thao tác trong quá trình hướng dẫn chỉ dùng để trải
						nghiệm và sẽ không được lưu vào hệ thống dữ liệu của
						trung tâm.
					</span>
				</div>
			</div>
			<button
				type="button"
				class="tutorial-welcome__button"
				@click="$emit('start')"
			>
				Bắt đầu ngay!
			</button>
		</div>
		<div class="tutorial-welcome__right">
			<img
				src="@/assets/images/tutorial/welcome-bg.png"
				alt=""
				class="tutorial-welcome__bg"
			/>
			<img
				src="@/assets/images/tutorial/welcome-mockup.png"
				alt=""
				class="tutorial-welcome__mockup"
			/>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TutorialWelcomeModal',
	emits: ['start'],
	data() {
		return {
			checklist: [
				'Thêm học sinh',
				'Mời trị liệu viên vào cơ sở',
				'Lên kế hoạch can thiệp cùng Luca AI',
				'Tạo mục tiêu can thiệp trong Ngân hàng mục tiêu',
				'Chỉnh sửa kế hoạch can thiệp',
			],
		};
	},
};
</script>

<style scoped>
.tutorial-welcome {
	display: flex;
	align-items: stretch;
	width: 988px;
	max-width: calc(100vw - 32px);
	border-radius: 16px;
	overflow: hidden;
	box-shadow: 0 0 1px rgba(12, 26, 75, 0.1),
		0 20px 24px rgba(20, 37, 63, 0.06);
}
.tutorial-welcome__left {
	display: flex;
	flex-direction: column;
	gap: 40px;
	width: 472px;
	flex-shrink: 0;
	padding: 40px;
	background: #fff;
}
.tutorial-welcome__logo {
	position: relative;
	width: 164px;
	height: 40px;
}
.tutorial-welcome__logo-mark {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 57.54%;
	overflow: hidden;
}
.tutorial-welcome__logo-mark img {
	position: absolute;
	top: -27.86%;
	left: -14.45%;
	width: 128.51%;
	height: 201.72%;
	max-width: none;
}
.tutorial-welcome__logo-text {
	position: absolute;
	top: 13.33px;
	left: calc(50% + 35.49px);
	transform: translateX(-50%);
	width: 88.21px;
	height: 24.46px;
}
.tutorial-welcome__content {
	display: flex;
	flex-direction: column;
	gap: 24px;
}
.tutorial-welcome__title {
	font-size: 20px;
	line-height: 28px;
	font-weight: 600;
	color: #344256;
}
.tutorial-welcome__text {
	font-size: 16px;
	line-height: 24px;
	color: #344256;
}
.tutorial-welcome__alert {
	display: flex;
	align-items: flex-start;
	gap: 12px;
	padding: 16px;
	border-radius: 5px;
	background: #eef3f8;
	font-size: 14px;
	line-height: 20px;
	font-weight: 600;
	color: #6390c3;
}
.tutorial-welcome__button {
	width: 100%;
	padding: 12px 20px;
	border-radius: 4px;
	background: #f0bb4f;
	font-size: 14px;
	line-height: 20px;
	font-weight: 600;
	color: #344256;
	box-shadow: 0 0 1px rgba(12, 26, 75, 0.24), 0 3px 8px rgba(50, 50, 71, 0.05);
}
.tutorial-welcome__right {
	position: relative;
	flex: 1;
	min-width: 0;
	overflow: hidden;
}
.tutorial-welcome__bg {
	position: absolute;
	top: calc(50% - 0.5px);
	left: calc(50% + 5px);
	width: 590px;
	height: 693px;
	max-width: none;
	transform: translate(-50%, -50%) rotate(180deg);
}
.tutorial-welcome__mockup {
	position: absolute;
	top: 50%;
	left: calc(50% + 48.5px);
	width: 563px;
	height: 676px;
	max-width: none;
	object-fit: cover;
	transform: translate(-50%, -50%);
}
@media (max-width: 1023px) {
	.tutorial-welcome {
		width: 472px;
	}
	.tutorial-welcome__left {
		width: 100%;
	}
	.tutorial-welcome__right {
		display: none;
	}
}
</style>
